import { themeTypeToBool } from './../../../../../utils/helpers';

export default theme => ({
    container: {
        maxHeight: "55vh"
    },
    headerRow: {
        background: themeTypeToBool(theme.palette.type) ? "#C6C6E8" : "inherit"
    }
});